import { useEffect, useState } from "react";
import { FormGenerarSolicitud } from "../interfaces/formGenerarSolicitud.interface";
import { selectorTransversal } from "../../../dtos/selector";
import { useOperacion } from "../../detalleMutuo/hooks/useOperacion";
import { CalcularPrepagoRequestInterface } from "../interfaces/calcularPrepagoRequest.interface";
import { calcularPrepagoService, generarSolicitudLiquidacionPrepago, obtenerFactorComisionService, obtenerMotivosPrepagoSercice } from "../services/servicePrepago";
import { RespuestaMotivosPrepagoDto, RespuestaCalcularPrepagoDto, RequestGrabarSolicitudDto } from "../models/index";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { AxiosResponse } from "axios";

const modosPago = [
    { value: 'Total a Pagar', label: 'Total a Pagar' },
    { value: 'Abono a Capital', label: 'Abono a Capital' },
];

const tiposPago = [
    { value: 'Total', label: 'Total' },
    { value: 'Parcial', label: 'Parcial' },
];

const medioPago = [
    { value: 'Vale Vista', label: 'Vale Vista' },
    { value: 'Cheque', label: 'Cheque' },
];

export function useGenerarSolicitud() {

    const { defaultValues: defaultValuesOperacion } = useOperacion();
    const [ prepagoCalculado, setPrepagoCalculado ] = useState<boolean>(false);
    const [ defaultValues, setDefaultValues ] = useState<FormGenerarSolicitud>({
        fechaSolicitud: new Date(),
        factorComisionPrepago: '',
        fechaPago: new Date(),
        modoPago: '',
        montoPrepago: '0',
        motivoPrepago: '',
        tipoPago: '',
        // DATOS QUE SE LLENAN AUTOMATICAMENTE AL CALCULAR
        montoPrepagoCapital: '',
        comisionPrepago: '',
        interesDevengado: '',
        seguroMesPrepago: '',
        provisionDividendos: '',
        montoDividendosImpagos: '',
        interesPenalDividendos: '',
        gastosCobranzaDividendo: '',
        totalPagar: '',
        gastosAlzamiento: '',
        tipoCambioMonedaOrigen: '',
        nuevoSaldoActual: '',
        desgravamenSeguros: '',
        otrosSeguros: '',
        saldoInsoluto: '',
        seguroCesantia: '',
        incendioSeguros: '',
        interesesDividendos: '',
        // DATOS ADICIONALES
        medioPago: '',
        banco: '',
        numeroTransaccionRequerimiento: ''
    });

    const [gastosAlzamiento, setGastosAlzamiento] = useState<RespuestaMotivosPrepagoDto[]>([]);
    const [listMotivoPrepago, setListMotivoPrepago] = useState<selectorTransversal[]>([]);
    const [listTipoPago, setListTipoPago] = useState<selectorTransversal[]>(tiposPago);
    const [listModoPago, setListModoPago] = useState<selectorTransversal[]>(modosPago);
    const [listMedioPago, setListMedioPago] = useState<selectorTransversal[]>(medioPago);

    const verifyGastosAlzamiento = (id: string) : boolean | null => {
        const gastos: RespuestaMotivosPrepagoDto | undefined = gastosAlzamiento.find((motivo) => motivo.codigo === id);
        return ( gastos ) ? gastos.gastosAlzamiento : null;
    }

    const calcularPrepago = async ( body: CalcularPrepagoRequestInterface ): Promise<RespuestaCalcularPrepagoDto> => {
        const response = await calcularPrepagoService(body);
        return response.data as RespuestaCalcularPrepagoDto;
    };

    const obtenerFactorComision = async ( idMutuo: number ): Promise<number> => {
        const response = await obtenerFactorComisionService(idMutuo);
        const factorComision = response.data?.result;

        if (response.status === 200 && typeof factorComision === "number") {
            return factorComision;
        }

        return 0;
    };

    const obtenerMotivosPrepago = async (): Promise<void> => {
        try {
            const response: AxiosResponse<ListResponseDto<RespuestaMotivosPrepagoDto>> = await obtenerMotivosPrepagoSercice();
            const motivos = response.data.items;
            setGastosAlzamiento(motivos);
            const motrivosAdapted = motivos.map(motivo => ({ value: motivo.codigo, label: motivo.descripcion }));
            setListMotivoPrepago(motrivosAdapted);
        } catch (error) {
            console.error(error);
            throw(error);
        }
    };

    const generarSolicitud = async (body: RequestGrabarSolicitudDto): Promise<any> => {
        const response = await generarSolicitudLiquidacionPrepago(body);
        return response;
    };

    useEffect(() => {
        setDefaultValues((prev) => ({
            ...prev,
            factorComisionPrepago: defaultValuesOperacion?.comisionPrepago?.toString() || ''
        }))
    }, [defaultValuesOperacion]);

    useEffect(() => {
        obtenerMotivosPrepago();
    }, []);

    return {
        prepagoCalculado,
        defaultValues,
        listModoPago,
        listMotivoPrepago,
        listTipoPago,
        listMedioPago,

        setPrepagoCalculado,
        calcularPrepago,
        obtenerFactorComision,
        generarSolicitud,
        verifyGastosAlzamiento
    };
}